export default __webpack_public_path__ + "static/persimmon-tree-pendant-wax-1153c4c3a5c1a2ced3f43bb6f3c36e5b.png";